import $ from "jquery";
import ElementFilter from "./util/element_filter";
import ElementFilterForm from "./util/element_filter_form";
import toastr from "toastr";
import URL from "url";

let timeout;
let statusUrl;
let downloadUrl;

const doDownloadRedirect = function (data) {
  window.location = data.s3_url;
  window.setTimeout(() => history.replaceState(null, $("title").text(), "/downloads"), 0);
  // TODO: Fix the url to remove the download thing, use replaceState
};

const handleDownloadRedirect = function () {
  const id = URL.parse(window.location.toString(), true).query.start_download;
  if (!id) {
    return;
  }
  $.ajax(`/downloads/${id}/s3_url`, {
    success: doDownloadRedirect,
    error: () => window.alert("Failed to start download")
  });
};

const showError = function () {
  toastr.error("Something went wrong while processing download", "Error");
  window.clearTimeout(timeout);
  setTimeout(() => {
    window.location.pathname = "downloads";
  }, 500);
};

const downloadNow = function () {
  window.location = downloadUrl;
};

const checkDownloadStatus = function () {
  $.ajax(statusUrl, {
    success: function (data) {
      if (data.status == "processing" || data.status == "not_started") {
        timeout = window.setTimeout(checkDownloadStatus, 1000);
      } else if (data.status == "complete") {
        downloadNow();
      } else {
        showError();
      }
    },
    error: showError
  });
};

const configureFilterForm = function () {
  const filter = new ElementFilter($("#downloads-table tbody"),
    "tr",
    [".col-name"]
  );

  const filterInput = $("#downloads_filter_filter");
  const form = filterInput.closest("form");
  new ElementFilterForm(form, filterInput, filter);
};

const configureDownloadStatusCheck = function () {
  const downloadStatus = $(".download-status[data-download-status-url][data-download-url]");
  // $('whater') always returns an object, it is never falsey. Check the length if you want to
  // verify an empty collection.
  if (downloadStatus.length === 0) {
    return;
  }

  statusUrl = downloadStatus.data("download-status-url");
  downloadUrl = downloadStatus.data("download-url");

  timeout = window.setTimeout(checkDownloadStatus, 1000);
};

$(document).on("turbolinks:load", function () {
  configureFilterForm();
  configureDownloadStatusCheck();
  handleDownloadRedirect();
});
